/*
 * tol-kouza-grid.js — 講座コレクション（collection.lecture-list）のスクール絞り込み
 * （R18・LB 7-33 D-3・DECISIONS 2026-09-11（4））
 * ------------------------------------------------------------------
 * 移植元 = ../expanse_live_260831/snippets/section-main-collection-kouza.liquid の IIFE（`var mapScript = document.getElementById('KouzaSchoolTagMap-'` を含む <script> ブロック・行番号は契約にしない）。
 * 読み込み = sections/tol-collection-grid.liquid（kouza_mode のときだけ・defer）。
 *
 * - LIVE は handle→タグ配列の JSON マップを解析し、カードに data 属性＋ style.display='none' !important を書く。
 *   ここでは各カードの器（[data-tol-kouza-card]）が data-tol-kouza-schools（'|' 区切り）を持つので、
 *   split 後の完全一致で hidden 属性をトグルするだけ（inline style も !important も使わない）。
 * - document への委譲（テーマエディターの section 再描画後もバインドし直しなしで動く・R16 同）。
 * - 状態は .is-active と aria-pressed だけで持つ。fetch も pushState もしない（LIVE 同・URL 状態なし）。
 * - 二重初期化ガード = window.__tolKouzaGridInit（エディターの再描画で script が再実行されても 1 組だけ）。
 * - ★2026-10（講座の絞り込み・assets/tol-kouza-facets.js と併用）: スクールで外れたことを
 *   data-tol-kouza-school-out="1" で持ち、hidden は「スクールで外れた or 絞り込み（data-kf-out）で外れた」で決める。
 *   スクールを変えたあとは window.tolKouzaFacets.refresh() で絞り込み側の件数表示も合わせ直す（無ければ何もしない）。
 */
(function () {
  'use strict';

  if (window.__tolKouzaGridInit) return;
  window.__tolKouzaGridInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-tol-kouza-filter] [data-tol-kouza-school]') : null;
    if (!btn) return;
    var bar = btn.closest('[data-tol-kouza-filter]');
    var section = bar ? bar.closest('[data-tol-collection-grid]') : null;
    var grid = section ? section.querySelector('[data-tol-kouza-grid]') : null;
    var tag = btn.getAttribute('data-tol-kouza-school') || '';

    Array.prototype.forEach.call(bar.querySelectorAll('[data-tol-kouza-school]'), function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    if (!grid) return;
    Array.prototype.forEach.call(grid.querySelectorAll('[data-tol-kouza-card]'), function (item) {
      var out = false;
      if (tag) {
        var schools = (item.getAttribute('data-tol-kouza-schools') || '').split('|').filter(Boolean);
        out = schools.indexOf(tag) === -1;
      }
      if (out) item.setAttribute('data-tol-kouza-school-out', '1');
      else item.removeAttribute('data-tol-kouza-school-out');
      item.hidden = out || item.getAttribute('data-kf-out') === '1';
    });
    if (window.tolKouzaFacets && typeof window.tolKouzaFacets.refresh === 'function') window.tolKouzaFacets.refresh();
  });
})();